import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';

interface ChatTypingIndicatorProps {
  isVisible?: boolean;
  text?: string;
  className?: string;
}

export const ChatTypingIndicator = ({
  isVisible = true,
  text = 'aiAssistant.typing',
  className = ''
}: ChatTypingIndicatorProps) => {
  const { t } = useTranslation();
  if (!isVisible) return null;

  return (
    <div className={cn('mb-3 flex w-full justify-start', className)}>
      <div className="max-w-[75%]">
        <div className="rounded-2xl rounded-bl-md border-base-border bg-white px-4 py-3 text-secondary shadow-sm">
          <div className="flex items-center gap-2">
            <div className="flex space-x-1">
              <div className="h-2 w-2 animate-bounce rounded-full bg-black-40 [animation-delay:-0.3s]"></div>
              <div className="h-2 w-2 animate-bounce rounded-full bg-black-40 [animation-delay:-0.15s]"></div>
              <div className="h-2 w-2 animate-bounce rounded-full bg-black-40"></div>
            </div>
            <span className="text-sm text-primary">{t(text)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
